"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Whatsapp = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Whatsapp = function Whatsapp(_a) {
  var id = _a.id;
  var clipPathId = id ? "Whatsapp__clip0__".concat(id) : 'Whatsapp__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.996 0a12 12 0 00-9.72 19.032l-1.08 3.288a.588.588 0 00.144.612c.115.115.27.18.432.18h.18l3.42-1.104A12 12 0 1011.996 0zm9.6 12a9.6 9.6 0 11-19.2 0 9.6 9.6 0 1119.2 0zm-5.664 5.616a2.796 2.796 0 001.98-1.428 2.4 2.4 0 00.192-1.416c-.058-.097-.21-.17-.418-.27l-.158-.078c-.288-.144-1.74-.864-2.016-.948a.576.576 0 00-.732.204 9.31 9.31 0 01-.78 1.056.66.66 0 01-.72.12 7.598 7.598 0 01-2.4-1.476 9.05 9.05 0 01-1.644-2.04.48.48 0 01.12-.636c.08-.1.164-.185.247-.27.067-.068.133-.135.197-.21.13-.14.239-.298.324-.468a.564.564 0 000-.552 121.22 121.22 0 01-.9-2.184c-.204-.504-.348-.504-.648-.504H8.24a1.512 1.512 0 00-1.044.36 3.288 3.288 0 00-1.104 2.472 5.724 5.724 0 001.2 3.048 12.492 12.492 0 005.04 4.464c2.4.96 3.072.876 3.6.756z",
    clipRule: "evenodd"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  }))));
};

exports.Whatsapp = Whatsapp;